<template>
  <div 
    class="card border-0 rounded-75 shadow-sm w-100 h-100 overflow-hidden"
    :class="{ 'p-3': !noPadding }"
  >
    <div class="card-body p-0">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noPadding: {
      type: Boolean,
      default: false
    }
  }
}
</script>